import { type ReactNode } from "react";
import classNames from "classnames";

import classes from "./Spinner.module.less";
import { useTranslation } from "react-i18next";

interface Props {
  className?: string;
  label?: ReactNode;
}

const Spinner = (props: Props) => {
  const { t } = useTranslation();

  return (
    <div className={classNames(classes.root, props.className)}>
      <div className={classes.bar}>
        <div className={classes.barInner} />
      </div>
      <p className={classes.text}>{props.label || t("spinner.text")}</p>
    </div>
  );
};

export default Spinner;
